import { createClient } from '@supabase/supabase-js'
import type { Database } from './database.types'

export const supabase = createClient<Database>(
  import.meta.env.VITE_SUPABASE_URL,
  import.meta.env.VITE_SUPABASE_ANON_KEY,
  {
    auth: {
      flowType: 'pkce',
      // Deliberately OFF. With detectSessionInUrl:true the client races to
      // exchange ?code= during init, colliding with the explicit exchange in
      // AuthCallback and burning the one-time code. One owner, one exchange.
      detectSessionInUrl: false,
      persistSession: true,
      autoRefreshToken: true,
      storageKey: 'side-action-auth',
    },
  }
)
